import styled from 'styled-components/macro';

export const S_PageStyle = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    float: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: -webkit-fill-available;
`;
